// assets
import { DashboardOutlined, UserOutlined, TrophyOutlined, FileTextOutlined, CommentOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  UserOutlined,
  TrophyOutlined,
  FileTextOutlined,
  CommentOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'clienti',
      title: 'Clienti',
      type: 'item',
      url: '/clienti',
      icon: icons.UserOutlined,
      breadcrumbs: false
    },
    {
      id: 'fatture-elettroniche',
      title: 'Fatture Elettroniche',
      type: 'item',
      url: '/fatture-elettroniche',
      icon: icons.FileTextOutlined,
      breadcrumbs: false,
      roles: ['admin', 'ufficio']
    },
    {
      id: 'fidelity',
      title: 'Gestione Fidelity',
      type: 'item',
      url: '/fidelity',
      icon: icons.TrophyOutlined,
      breadcrumbs: false
    },
    {
      id: 'assistente-admin',
      title: 'Assistente Admin',
      type: 'item',
      url: '/assistente-admin',
      icon: icons.CommentOutlined,
      breadcrumbs: false,
      roles: ['admin']
    }
  ]
};

export default dashboard;
